import { render, staticRenderFns } from "./AiChatPanel.vue?vue&type=template&id=28925f16&scoped=true"
import script from "./AiChatPanel.vue?vue&type=script&lang=js"
export * from "./AiChatPanel.vue?vue&type=script&lang=js"
import style0 from "./AiChatPanel.vue?vue&type=style&index=0&id=28925f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28925f16",
  null
  
)

export default component.exports